import React from "react";

import { Flex } from "antd";

import { ExperimentTaggingWorkspace } from "../components/tagging/ExperimentTaggingWorkspace";
import { useExperimentEditor } from "../hooks/useExperimentEditor";

export const ExperimentTaggingPage: React.FC = () => {
  const { experimentData, selectedExperiment, setExperimentData } =
    useExperimentEditor();
  const coreResearchQuestionOptions = React.useMemo(
    () =>
      (selectedExperiment?.premises ?? []).flatMap((premise) => {
        const id = premise.id?.trim();
        if (premise.type !== 1 || !id) {
          return [];
        }

        return [
          {
            id,
            value: premise.value.trim() || "Untitled core research question",
          },
        ];
      }),
    [selectedExperiment?.premises],
  );

  return (
    <Flex vertical style={{ flex: 1, overflow: "hidden" }}>
      <ExperimentTaggingWorkspace
        experimentData={experimentData}
        setExperimentData={setExperimentData}
        coreResearchQuestions={coreResearchQuestionOptions}
      />
    </Flex>
  );
};

export default ExperimentTaggingPage;
